module.exports = __webpack_public_path__ + "img/28.94ba4448.jpg";